/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PayerContract } from './PayerContract';
import {
    PayerContractFromJSON,
    PayerContractFromJSONTyped,
    PayerContractToJSON,
    PayerContractToJSONTyped,
} from './PayerContract';

/**
 * 
 * @export
 * @interface CreatePayerContracts201Response
 */
export interface CreatePayerContracts201Response {
    /**
     * 
     */
    data?: PayerContract;
}

/**
 * Check if a given object implements the CreatePayerContracts201Response interface.
 */
export function instanceOfCreatePayerContracts201Response(value: object): value is CreatePayerContracts201Response {
    return true;
}

export function CreatePayerContracts201ResponseFromJSON(json: any): CreatePayerContracts201Response {
    return CreatePayerContracts201ResponseFromJSONTyped(json, false);
}

export function CreatePayerContracts201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePayerContracts201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PayerContractFromJSON(json['data']),
    };
}

export function CreatePayerContracts201ResponseToJSON(json: any): CreatePayerContracts201Response {
    return CreatePayerContracts201ResponseToJSONTyped(json, false);
}

export function CreatePayerContracts201ResponseToJSONTyped(value?: CreatePayerContracts201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PayerContractToJSON(value['data']),
    };
}

